<template>
  <div>
    <BlockUI v-if="loading">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>

    <div id="main-container" class="text-initial" v-if="space">
      <div
        class="warning-banner"
        v-if="user.role === 'superadmin' && space.status === 'to_approve'"
      >
        {{ $t("dashboard.superadmin.pending.warning") }}
      </div>

      <div class="d-flex justify-content-between">
        <Contact :info="form" :isEdit="false" />
        <b-button
          pill
          variant="primary"
          id="edit-button"
          class="col-6"
          @click="edit"
          v-if="user.role === 'space_owner'"
        >
          {{ $t("utils.button.edit-profile") }}
        </b-button>
        <LoadingButton
          :text="$t('utils.button.revert-publication')"
          :classes="['btn-primary', 'px-5']"
          v-if="user.role === 'superadmin' && space.status === 'approved'"
          @click="revert()"
        />
      </div>
      <Space :info="form" :isEdit="false" />
      <Pictures :info="form" :isEdit="false" />
      <div id="description-container" class="mt-4">
        <h3>{{ $t("utils.description") }}</h3>
        <div id="textarea">
          <p>{{ form.description }}</p>
        </div>
      </div>
      <Tags :info="form" :isEdit="false" />
      <Hours :info="form" :isEdit="false" />
      <div
        class="mt-5"
        id="seat-table"
        v-if="user.role === 'superadmin' && (space.status === 'approved' || space.status === 'to_approve')"
        >
          <h4>Seat Table</h4>
          <b-table striped hover :items="seats" :fields="fields" :busy="loading">
            <template #table-busy>
              <div class="text-center text-secondary my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
          </b-table>
      </div>
      <Agreement />

      <div
        class="mt-3"
        v-if="user.role === 'superadmin' && space.status === 'rejected'"
      >
        <div class="warning-banner">
          <h4>{{ $t("dashboard.superadmin.spaces.rejected-reason") }}</h4>
          {{ space.note }}
        </div>

        <button class="btn btn-primary" id="approve-btn" @click="publish()">
          {{ $t("utils.button.approve-publish") }}
        </button>
      </div>

      <div
        class="
          buttons-container
          d-flex
          flex-column
          justify-content-start
          mt-4
        "
        v-if="user.role === 'superadmin' && space.status === 'to_approve'"
      >
        <div id="fee-container" class="pb-4">
          <h4>Add Fee</h4>
          <input type="number" id="fee-input" v-model="fee"> %
          <button id="fee-btn" class="btn btn-primary ms-4" @click="addFeeSpace()" :disabled="fee <= 0">Confirm fee</button>
        </div>
        <div>
          <button
            class="btn btn-secondary"
            id="reject-btn"
            @click="showRejectDialog()"
          >
            {{ $t("utils.button.reject") }}
          </button>
          <button
            class="btn btn-primary ms-3"
            id="approve-btn"
            :disabled="!feeIsAdd"
            @click="publish()"
          >
            {{ $t("utils.button.approve-publish") }}
          </button>
        </div>
      </div>
    </div>

    <MessageBanner
      :message="error"
      :type="'error'"
      :classes="['position-bottom-center']"
      v-if="error !== ''"
    />

    <RejectDialog @rejected="rejectSpace($event)" />
  </div>
</template>

<script>
import Contact from "./components/Contact";
import Space from "./components/Space";
import Pictures from "./components/Pictures";
import Tags from "./components/Tags";
import Hours from "./components/Hours";
import Agreement from "./components/Agreement";
import RejectDialog from "./components/RejectDialog";

import SpaceService from "@/services/space";

import { mapGetters } from "vuex";

export default {
  components: {
    Contact,
    Space,
    Pictures,
    Tags,
    Hours,
    Agreement,
    RejectDialog
  },
  data() {
    return {
      form: {
        name: "",
        surname: "",
        role: "",
        coworkingName: "",
        website: "",
        phone: "",
        pictureURLs: [],
        description: "",
        selectedFeatures: [],
        selectedStyle: [],
        selectedAspect: [],
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        field: "",
        hours: null,
        location: "",
        city: "",
        address: "",
        searchResults: [],
        service: null,
        place: null,
        locationDetails: {},
        isCheckedDay: true
      },
      busy: "",
      fields: [
        { key: "name", label: this.$t("utils.table.name") },
        { key: "people_fitting", label: this.$t("dashboard.seats.edit.people-fitting") },
        { key: "price_hour", label: this.$t("utils.table.price-hour") },
        { key: "price_day", label: this.$t("utils.table.price-day") },
        { key: "stock", label: this.$t("dashboard.seats.edit.spots") },
        { key: "actions", label: "" }
      ],
      seats: [
        {
          name: this.$t("dashboard.seats.edit.easy-chair"),
          price_hour: null,
          price_day: null,
          people_fitting: null,
          stock: null,
          description: "",
          isNew: true,
          type: "easy_chair"
        },
        {
          name: this.$t("dashboard.seats.edit.private-desk"),
          price_hour: null,
          price_day: null,
          people_fitting: null,
          stock: null,
          description: "",
          isNew: true,
          type: "private_desk"
        },
        {
          name: this.$t("dashboard.seats.edit.meeting-rooms"),
          price_hour: null,
          price_day: null,
          people_fitting: null,
          stock: null,
          description: "",
          isNew: true,
          type: "meeting_room"
        }
      ],
      fee: 0,
      feeIsAdd: false,
      loading: false,
      success: false,
      error: "",
      space: null
    };
  },
  computed: {
    ...mapGetters("currentUser", ["user"]),
    ...mapGetters("currentUser", ["spaceId"]),
    ...mapGetters("space", ["status"])
  },
  methods: {
    edit() {
      if (this.spaceId) {
        location.href = `/space/${this.spaceId}/edit`;
      } else {
        location.href = `/space/edit`;
      }
    },

    showRejectDialog() {
      this.$root.$emit("bv::show::modal", "reject-modal");
    },

    async publish() {
      try {
        this.loading = true;

        await SpaceService.changeSpaceStatus(this.space.id, "approved");

        this.$router.push({ name: "SuperadminActiveSpacesPage" });
      } catch (error) {
        if (typeof error.response.data.message !== "string") {
          this.error = error.response.data.message[0];
        } else {
          this.error = error.response.data.message;
        }

        setTimeout(() => {
          this.error = "";
        }, 2500);
      } finally {
        this.loading = false;
      }
    },
    async addFeeSpace() {
      const response = await SpaceService.getSpaceById(this.$route.params.id);
      let space = response.data;
      space.fee = +this.fee;
      await SpaceService.updateSpace(
            this.$route.params.id,
            space
          );
      await this.$store.dispatch("space/setSpace", space);
      this.feeIsAdd = true;
    },
    async rejectSpace(reason) {
      this.$root.$emit("bv::hide::modal", "reject-modal");

      try {
        this.loading = true;

        await SpaceService.changeSpaceStatus(this.space.id, "rejected", reason);

        this.$router.push({ name: "SuperadminRejectedSpacesPage" });
      } catch (error) {
        if (typeof error.response.data.message !== "string") {
          this.error = error.response.data.message[0];
        } else {
          this.error = error.response.data.message;
        }

        setTimeout(() => {
          this.error = "";
        }, 2500);
      } finally {
        this.loading = false;
      }
    },
    async getSeats() {
      this.loading = true;
      try {
        const { data } = await SpaceService.getSpaceById(this.$route.params.id);
        this.seats = this.mapSeats(data.products);
      } catch (error) {
        this.error = error.response.data.message;

        setTimeout(() => {
          this.error = "";
        }, 2500);
      } finally {
        this.loading = false;
        this.busy = false;
      }
    },
    mapSeats(products) {
      const currencies = new Map();
      currencies.set('eur', '€');
      currencies.set('dollar', '$');
      currencies.set('pound', '£');
      const mappedProduct = products.map(product => ({
        id: product.id,
        name: this.mapSeatType(product.type),
        price_hour: product.priceTypes.filter((price) => price.type === 'hourly').length !== 0 ? `${+product.priceTypes.filter((price) => price.type === 'hourly').map((el) => el.value)} ${currencies.get(product.priceTypes.map((el) => el)[0].currency)}` : null,
        price_day: product.priceTypes.filter((price) => price.type === 'daily').length !== 0 ? `${+product.priceTypes.filter((price) => price.type === 'daily').map((el) => el.value)} ${currencies.get(product.priceTypes.map((el) => el)[0].currency)}` : null,
        price_currency: `${currencies.get(product.priceTypes.map((el) => el)[0].currency)}`,
        type: product.type,
        description: product.description,
        people_fitting: product.peopleFitting,
        stock: product.numberOfSpots
      }));
      const easyChair = mappedProduct.find(
        product => product.type === "easy_chair"
      );

      const privateDesk = mappedProduct.find(
        product => product.type === "private_desk"
      );

      const meetingRoom = mappedProduct.find(
        product => product.type === "meeting_room"
      );

      return [
        easyChair || this.seats[0],
        privateDesk || this.seats[1],
        meetingRoom || this.seats[2]
      ];
    },
        mapSeatType(seatType) {
      if (seatType === "easy_chair") {
        return this.$t("dashboard.seats.edit.easy-chair");
      } else if (seatType === "private_desk") {
        return this.$t("dashboard.seats.edit.private-desk");
      } else if (seatType === "meeting_room") {
        return this.$t("dashboard.seats.edit.meeting-rooms");
      }
    },
    async revert() {
      try {
        this.loading = true;

        await SpaceService.changeSpaceStatus(this.space.id, "to_approve");

        this.$router.push({ name: "SuperadminPendingSpacesPage" });
      } catch (error) {
        if (typeof error.response.data.message !== "string") {
          this.error = error.response.data.message[0];
        } else {
          this.error = error.response.data.message;
        }

        setTimeout(() => {
          this.error = "";
        }, 2500);
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    if (
      (!this.status && this.user.role !== "superadmin") ||
      this.status === "draft" ||
      (this.status === "rejected" && this.user.role !== "superadmin")
    ) {
      this.$router.push({ name: "WelcomePage" });
    } else {
      this.$store.dispatch("utils/setSectionName", "");
      this.$store.dispatch("sidebar/setAction", "published");
      this.loading = true;
      this.getSeats();
      try {
        const response = await SpaceService.getSpaceById(this.$route.params.id);

        this.space = response.data;

        this.form = {
          email: response.data.email,
          description: response.data.description,
          hours: response.data.hours,
          city: response.data.location.city,
          address: response.data.location.address,
          coworkingName: response.data.name,
          phone: response.data.phone,
          pictureURLs: response.data.pictureURLs,
          selectedFeatures: response.data.tags.features,
          selectedAspect: response.data.tags.socials,
          selectedStyle: response.data.tags.styles,
          website: response.data.website
        };

        for (let day in this.form.hours) {
          if (this.form.hours[day]) {
            this.form.hours[day] = {
              start: this.$moment(this.form.hours[day].start).format("HH:mm"),
              end: this.$moment(this.form.hours[day].end).format("HH:mm")
            };
            this.form[day] = true;
          } else {
            this.form.hours[day] = { start: "09:00", end: "18:00" };
          }
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";
@import "src/assets/scss/buttons";

#main-container {
  margin-left: 50px;
  min-height: calc(100vh - 100px);
  padding-bottom: 50px;
}

#edit-button {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  margin-right: 18px;
  background-color: #7e4ee2;
  border-radius: 24px;
  width: 213px;
  height: 48px;
  border: #7e4ee2;

  &:focus {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #7e4ee2;
  }
}

::placeholder {
  color: #000000;
}

#description-container {
  width: 690px;
  height: 151px;

  h3 {
    font-family: $inter;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #767676;
  }
}

#textarea {
  width: 670px;
  height: 130px;
  border: none;
  background-color: #e5e5e5;
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  padding-top: 5px;
  text-align: initial;
}

.warning-banner {
  background: #ffcaca;
  width: fit-content;
  padding: 20px;
  margin-bottom: 25px;
  font-family: $worksans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #161616;

  h4 {
    font-family: $worksans;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    color: #161616;
    margin-bottom: 18px;
  }
}

#fee-container {
  h4 {
    font-family: $worksans;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    color: #161616;
    margin-bottom: 18px;
  }

  #fee-input {
  width: 80px;
  border: 1.6px solid #000000;
  box-sizing: border-box;
  border-radius: 6px;
  background-color: #E5E5E5;
  }

  #fee-btn {
    height: 40px;
    min-width: 140px;
  }
}

#seat-table {
  width: 60%;
  h4 {
    font-family: $worksans;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    color: #161616;
    margin-bottom: 18px;
  }
}

#reject-btn {
  min-width: 210px;
}

#approve-btn {
  min-width: 245px;
}
</style>



// WEBPACK FOOTER //
// src/pages/info/InfoPage.vue